export function defaultNullHtml() {
  return `<i class="fas fa-times default-null-html"></i>`;
}
